import insuranceFieldsValidations from './insuranceFieldsValidations';

function validateInsuranceEntry(insurance) {
  const entryErrors = {};

  const planTypeError = insuranceFieldsValidations.isRequiredPaymentsPlanType({
    values: insurance,
    value: insurance?.plan_type,
  });
  if (planTypeError) entryErrors.plan_type = planTypeError;

  const planError = insuranceFieldsValidations.isRequiredPaymentsPlan({
    values: insurance,
    value: insurance?.plan,
  });
  if (planError) entryErrors.plan = planError;

  const memberIdError = insuranceFieldsValidations.isRequiredPaymentsMemberId({
    values: insurance,
    value: insurance?.member_id,
  });
  if (memberIdError) entryErrors.member_id = memberIdError;

  return entryErrors;
}

/**
 * Validates insurance fields for the parent form's react-final-form validate function.
 * Returns errors in the shape { insurance: [{ plan_type: '...', plan: '...', member_id: '...' }] }
 * for react-final-form to prevent form submission when required fields are incomplete.
 *
 * @param {Object} values - Form values (must include values.insurance array)
 * @param {boolean} shouldValidateInsurance - Whether to validate insurance (e.g. isFocused(currentGroup, INSURANCE))
 * @returns {Object} Errors object for react-final-form, or empty object if no errors
 */
export function validateInsuranceForParentForm(values, shouldValidateInsurance) {
  if (!shouldValidateInsurance) return {};

  const insuranceEntries = values?.insurance || [];
  const insuranceErrors = insuranceEntries.map(validateInsuranceEntry);
  const hasInsuranceErrors = insuranceErrors.some(
    (entry) => Object.keys(entry).length > 0,
  );

  return hasInsuranceErrors ? { insurance: insuranceErrors } : {};
}

export default validateInsuranceForParentForm;
